window.getNavButtonPosition = (targetSelector, containerSelector) => {
    if (!targetSelector || !containerSelector) return -1;

    const target = document.querySelector(targetSelector);
    const container = document.querySelector(containerSelector);

    if (!target || !container) return -1;

    const targetRect = target.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    return targetRect.top - containerRect.top;
};